// Save this in src/utils/withRouter.js or anywhere appropriate
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import React from 'react';

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}
